import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
export class PylosHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        const ownershipMap = node.gameState.getPiecesRepartition();
        return ownershipMap.toTable();
    }
}
